export function replaceKeys(original, values = {}) {
    let transformed = original;

    Object.keys(values).forEach(key => {
        transformed = transformed.replace(`%{${key}}`, values[key]);
    })
    return transformed;
}



// WEBPACK FOOTER //
// ./js/marketing/utils/internationalisation-utils.js